// update access token
const updateAccess = (newAccess) => {
  let state = getUserState();
  if (state && state.access) {
    state.access = newAccess;
  }
  setUserState(state);
}

// get tenken user state
const getUserState = () => {
  let state = localStorage.getItem('tenkenUserState');
  return state ? JSON.parse(state) : {};
}

// set tenken user state
const setUserState = (state) => {
  return localStorage.setItem('tenkenUserState', JSON.stringify(state));
}

const setFlash = (name, message) => {
  sessionStorage.setItem(name, message);
}

const getFlash = (name) => {
  let message = sessionStorage.getItem(name);
  sessionStorage.removeItem(name);
  return message;
}

export {
  setUserState, getUserState, updateAccess, setFlash, getFlash
}